import { BaseViewStore } from 'core/stores';
import { observable, action, makeObservable } from 'mobx';
import { sourceOfChange, viewStoreName } from 'common/constants';
import { FulfillmentOrderStore } from 'modules/order/stores';
import { LookupStore } from 'modules/lookup/stores';
import { ShipmentInfoStore } from 'modules/shipment-info/stores';
import { notificationError, translate } from 'core/utils';
import _ from 'lodash';

class NeverShippedViewStore extends BaseViewStore {
	@observable selectedVoidLabelOption = null;
	@observable disableSaveBtn = true;
	@observable voidOnChannel = false;
	selectedItem = null;
	selectedItems = [];
	isBulkAction;
	showVoidOnChannel;

	constructor(rootStore, { parentViewStore, selectedItems }) {
		super(rootStore);
		makeObservable(this);
		this.parentView = parentViewStore;
		this.selectedItems = selectedItems;
		this.lookupStore = new LookupStore(rootStore);
		this.fulfillmentOrderStore = new FulfillmentOrderStore(rootStore);
		this.shipmentInfoStore = new ShipmentInfoStore(rootStore);
		this.isBulkAction = this.parentView.isBulkNeverShipped;
		this.showVoidOnChannel = this.parentView.showVoidOnChannel;
	}

	@action.bound
	onCheck = async check => {
		if (check) {
			this.voidOnChannel = !this.voidOnChannel;
		}
	};

	closeModal = () => {
		this.parentView.neverShippedModal.close();
	};

	@action.bound async markNeverShipped() {
		const notificationId = this.rootStore.notificationStore.load(translate('BULKNOTIFICATION.NEVERSHIPPED'));
		this.parentView.neverShippedModal.close();
		try {
			if (this.isBulkAction) {
				const fulfillmentOrderIds = _.map(this.parentView.selectedItems, item => {
					return item.id;
				});
				await this.fulfillmentOrderStore.neverShippedBulk(
					{ fulfillmentOrderIds: fulfillmentOrderIds },
					this.voidOnChannel,
					sourceOfChange.neverShipped
				);
				this.rootStore.notificationStore.success('ORDERVIEW.NEVERSHIPPEDBULKSUCCESS');
				this.parentView.findFulfillmentOrders();
			} else {
				const neverShippedParams = {
					fulfillmentOrderId: this.parentView.selectedItem.id,
					voidLabelOnChannel: this.voidOnChannel,
				};
				await this.fulfillmentOrderStore.neverShipped(neverShippedParams, sourceOfChange.neverShipped);
				this.rootStore.notificationStore.success([
					'ORDERVIEW.NEVERSHIPPEDSUCCES',
					{ id: this.parentView.selectedItem.fulfillmentOrderId },
				]);

				if (this.parentView.store_path === viewStoreName.orderListViewStore) {
					this.parentView.findFulfillmentOrders();
				} else {
					this.parentView.initialize();
				}
			}
		} catch (err) {
			notificationError({ store: this.rootStore.notificationStore, err });
		}
		this.rootStore.notificationStore.dismiss(notificationId);
	}
}

export default NeverShippedViewStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/NeverShippedViewStore.js